var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reset-password"},[_c('modal',[_c('div',{staticClass:"body",attrs:{"slot":"body"},slot:"body"},[_c('cactus-password-forgotten',{attrs:{"userParam":_vm.userNameParam,"codeParam":_vm.resetCodeParam}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }